import { ColumnConfig } from './column-config.model';

export class ColumnFilter {
    column: ColumnConfig;
    filter: any;
}